<template>
  <div class="formate-box">
    <span class="formate-icon">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="27.556"
        height="36.75"
        viewBox="0 0 27.556 36.75"
      >
        <path
          d="M9.185-5.356v2.3h2.3v-2.3ZM13.915,6.815a.856.856,0,0,0-.847-.689H11.482v-2.3h-2.3v2.3L7.793,13.1a3.763,3.763,0,1,0,7.377,0ZM11.5,15.749a2.158,2.158,0,0,1-2.325-1.938A2.158,2.158,0,0,1,11.5,11.874a2.158,2.158,0,0,1,2.325,1.938A2.158,2.158,0,0,1,11.5,15.749ZM9.185-.763v2.3h2.3v-2.3Zm4.593-6.889h-2.3v2.3h2.3ZM26.545-5.22l-6.021-6.021a3.445,3.445,0,0,0-2.433-1.012H3.445A3.456,3.456,0,0,0,0-8.8V21.053A3.445,3.445,0,0,0,3.445,24.5H24.112a3.445,3.445,0,0,0,3.445-3.445V-2.78A3.461,3.461,0,0,0,26.545-5.22ZM18.371-9.913a1.1,1.1,0,0,1,.531.3l6.021,6.021a1.156,1.156,0,0,1,.3.531H18.371ZM25.26,21.053A1.152,1.152,0,0,1,24.112,22.2H3.445A1.152,1.152,0,0,1,2.3,21.053V-8.8A1.152,1.152,0,0,1,3.445-9.949H9.164v2.3h2.3v-2.3h4.614v7.463A1.718,1.718,0,0,0,17.8-.763H25.26ZM13.778,1.533h-2.3v2.3h2.3Zm0-4.593h-2.3v2.3h2.3Z"
          transform="translate(0 12.253)"
        />
      </svg>
    </span>
  </div>
</template>
<script>
export default {
  name: 'ZipViewer',
};
</script>
